import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "flex mt-5",
  style: {"justify-content":"center"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "flex",
  style: {"justify-content":"end"}
}
const _hoisted_4 = {
  align: "center",
  style: {"padding":"5%"}
}
const _hoisted_5 = {
  class: "text-subtitle-1 text-medium-emphasis",
  align: "start"
}
const _hoisted_6 = {
  class: "text-subtitle-1 mt-2 text-medium-emphasis",
  align: "start"
}
const _hoisted_7 = {
  key: 0,
  class: "calendar mt-5",
  style: {"padding":"0px 20px"}
}

import { useI18n } from "vue-i18n"
import {
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  computed,
} from "vue"

import { RequestResponse } from "@/types"

import FullCalendar from "@fullcalendar/vue3"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import moment from "moment"
import timeGridPlugin from "@fullcalendar/timegrid"
import listPlugin from "@fullcalendar/list"
import deLocale from "@fullcalendar/core/locales/de"

export interface CalendarEvents {
  id: string
  title: string
  start: Date
  end: Date
  color?: string
  textColor?: string
  startEditable: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarProfileComponent',
  props: {
    manualTime: {},
    useCalendarSearch: { type: Boolean }
  },
  emits: ["saved", "changedCalendarSearch"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const emit = __emit
const events = ref<CalendarEvents[]>([])
const singleTimeWindow = ref<any[]>([["", ""], 1])

const enterManualTime = ref<boolean>(false)
const calendarOptions = ref({
  plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
  initialView: "dayGridMonth",
  headerToolbar: {
    left: "prev next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,listWeek",
  },
  selectable: true,
  timezone: "local",
  weekends: true,
  events: events.value,
  displayEventTime: false,
  locale: localStorage.getItem("locale") == "de" ? deLocale : "en",
  eventClick: function (info: any) {
    singleTimeWindow.value[0][0] = moment(info.event.start)
      .locale("de")
      .toDate()
    singleTimeWindow.value[0][1] = moment(info.event.end).locale("de").toDate()
    singleTimeWindow.value[1] = getNumberOfApplicants(info.event._def.publicId)
    index.value = parseInt(info.event._def.publicId)
    canDeleteTimerPeriod.value = true
    enterManualTime.value = true
  },
  select: function (info: any) {
    singleTimeWindow.value[0][0] = info.start
    singleTimeWindow.value[0][1] = info.end
    addingNewTimeWindow.value = true
    enterManualTime.value = true
  },
})

const minRule = [
  (v: number) => !!v || t("required"),
  (v: number) => v > 0 || t("min-student-required"),
]
const isLoading = ref(true)
const addingNewTimeWindow = ref(false)

const props = __props
const index = ref<number>(props.manualTime.length - 1)
const activeSearch = ref(props.useCalendarSearch ?? false)
const canDeleteTimerPeriod = ref(false)

onMounted(async () => {
  window.addEventListener("locale-changed", updateCalendarLocale)
  calendarOptions.value.events = [...events.value]

  isLoading.value = false
})

onBeforeUnmount(() => {
  window.removeEventListener("locale-changed", updateCalendarLocale)
})

const deleteTimeWindow = () => {
  singleTimeWindow.value[1] = parseInt(singleTimeWindow.value[1])

  const data = {
    timeWindow: singleTimeWindow.value,
    index: index.value,
    addingNewTimeWindow: addingNewTimeWindow.value,
    deletingTimeWindow: true,
    useCalendarSearch: true,
  }

  emit("saved", data)

  enterManualTime.value = false
}

const saveProfile = (useCalendarNewVal: boolean) => {
  singleTimeWindow.value[1] = parseInt(singleTimeWindow.value[1])

  const data = {
    timeWindow: singleTimeWindow.value,
    index: index.value,
    addingNewTimeWindow: addingNewTimeWindow.value,
    deletingTimeWindow: false,
    useCalendarSearch: useCalendarNewVal,
  }

  emit("saved", data)

  enterManualTime.value = false
}

const infoCompleted = computed((): boolean => {
  return (
    singleTimeWindow.value[0][0] !== null &&
    singleTimeWindow.value[0][0] !== "" &&
    singleTimeWindow.value[0][1] !== null &&
    singleTimeWindow.value[0][1] !== "" &&
    singleTimeWindow.value[1] >= 1
  )
})

const updateCalendarLocale = () => {
  calendarOptions.value.locale =
    localStorage.getItem("locale") == "de" ? deLocale : "en"
  buildEvents(props.manualTime)
}

const getNumberOfApplicants = (index: string): number => {
  let val = 1
  props.manualTime.forEach((newVal, i) => {
    if (i.toString() == index) {
      val = newVal[1]
    }
  })
  return val
}

watch(
  () => enterManualTime,
  (enterManualTime) => {
    if (!enterManualTime.value) {
      addingNewTimeWindow.value = false
      canDeleteTimerPeriod.value = false
    }
  },
  { deep: true, immediate: true }
)

const buildEvents = (manualTime: any[][]) => {
  manualTime.forEach((singleTimeWindow: any[], index) => {
    events.value.push({
      title: `${t("calendar-open")} ${singleTimeWindow[1]} ${t("interns")}`,
      start: moment(singleTimeWindow[0][0]).locale("de").toDate(),
      end: moment(singleTimeWindow[0][1]).locale("de").toDate(),
      color: "#25344d",
      id: index.toString(),
      startEditable: false,
    })
  })
  calendarOptions.value.events = [...events.value]
}

watch(
  () => props.manualTime,
  (newVal) => {
    isLoading.value = true

    if (newVal) {
      buildEvents(newVal)
    }
    isLoading.value = false
  },
  { deep: true, immediate: true }
)

watch(
  () => props.useCalendarSearch,
  (newVal) => {
    isLoading.value = true

    activeSearch.value = newVal
    isLoading.value = false
  },
  { deep: true, immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_switch, _mergeProps(props, {
            modelValue: activeSearch.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSearch).value = $event)),
            color: "primary",
            label: _ctx.$t('doctor.calender'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (saveProfile(!activeSearch.value)))
          }), null, 16, ["modelValue", "label"])
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$t("doctor.calender-tip")), 1)
        ]),
        _: 1
      })
    ]),
    (activeSearch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_dialog, {
            modelValue: enterManualTime.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((enterManualTime).value = $event)),
            "max-width": "500"
          }, {
            activator: _withCtx(({ props: activatorProps }) => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_btn, _mergeProps(activatorProps, {
                  color: "#3fb984",
                  class: "mr-4"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("add-time-period")), 1)
                  ]),
                  _: 2
                }, 1040)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                "prepend-icon": "mdi-calendar",
                text: _ctx.$t('add-time-period-text'),
                title: _ctx.$t('add-time-period')
              }, {
                actions: _withCtx(() => [
                  (canDeleteTimerPeriod.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mt-2 ml-2 mb-2",
                        density: "compact",
                        color: "red",
                        icon: "mdi-trash-can-outline",
                        onClick: deleteTimeWindow
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (enterManualTime.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("go-back")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (saveProfile(_ctx.useCalendarSearch))),
                    disabled: !infoCompleted.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Speichern")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("time-period")), 1),
                    _createVNode(_component_VueDatePicker, {
                      modelValue: singleTimeWindow.value[0],
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((singleTimeWindow.value[0]) = $event)),
                      range: "",
                      "enable-time-picker": false,
                      "min-date": Date.now(),
                      teleport: true,
                      clearable: false,
                      format: "dd MMM yyyy"
                    }, null, 8, ["modelValue", "min-date"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.$t("number-students")) + " ", 1),
                      _createVNode(_component_v_tooltip, { location: "top" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps(props, {
                            icon: "mdi-help-circle-outline",
                            color: "#3fb984"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("number-students-tip")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      placeholder: _ctx.$t('number-students'),
                      modelValue: singleTimeWindow.value[1],
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((singleTimeWindow.value[1]) = $event)),
                      "hide-details": "",
                      "single-line": "",
                      type: "number",
                      rules: minRule
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["text", "title"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(FullCalendar), {
                  options: calendarOptions.value,
                  class: "mt-7"
                }, null, 8, ["options"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})